<template>
	<div class="main-area">
		<transition name="fade" mode="out-in">
			<!--关于我们-->
			<div class="main-con" v-if="$name=='about'" :style="[aboutMainStyle]">
				<x-about-xhorse></x-about-xhorse>
				<x-about-patents></x-about-patents>
				<x-about-business></x-about-business>
				<x-about-power></x-about-power>
				<x-about-employe></x-about-employe>
				<x-about-respons></x-about-respons>
				<x-about-where></x-about-where>
			</div>
			<!--解决方案-->
			<div class="main-con" v-if="$name=='solution'">
				<template v-if="getActivePath">
					<!--<template>{{ getActivePath}} : {{ getActiveMain }}</template>-->
					<!------------------------------------------------------------------------------------------------->
					<x-solution-key-cutting-machine
					v-if="getActivePath[1]==1&&getActiveMain[0]==1"
					:activeSideIndex="activeSideIndex"
					></x-solution-key-cutting-machine>
					<!------------------------------------------------------------------------------------------------->
					<x-solution-vvdi-universal-remote-series
					v-if="getActivePath[1]==2&&(getActiveMain[0]==1||getActiveMain[0]==2)"
					:activeSideIndex="activeSideIndex"
					></x-solution-vvdi-universal-remote-series>
					<!------------------------------------------------------------------------------------------------->
					<x-solution-ic-programmers
					v-if="getActivePath[1]==3&&(getActiveMain[0]==1||getActiveMain[0]==3)"
					:activeSideIndex="activeSideIndex"
					></x-solution-ic-programmers>
					<!------------------------------------------------------------------------------------------------->
					<x-solution-access
					v-if="getActivePath[1]==4&&(getActiveMain[0]==1||getActiveMain[0]==4)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-access>
					<!------------------------------------------------------------------------------------------------->
					<x-solution-hpc
					v-if="getActivePath[1]==5&&(getActiveMain[0]==1||getActiveMain[0]==5)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-hpc>
					<!------------------------------------------------------------------------------------------------->
					<x-solution-xhorse-asic-team
					v-if="getActivePath[1]==6&&(getActiveMain[0]==1||getActiveMain[0]==6)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-xhorse-asic-team>
					<!------------------------------------------------------------------------------------------------->
					<x-solution-desktop-asix-engraving
					v-if="getActivePath[1]==7&&(getActiveMain[0]==1)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-desktop-asix-engraving>

					<x-solution-axis-tool-sharpener
					v-if="getActivePath[1]==7&&(getActiveMain[0]==2)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-axis-tool-sharpener>

					<x-solution-dental-carving-machine
					v-if="getActivePath[1]==7&&(getActiveMain[0]==3)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-dental-carving-machine>

					<x-solution-axis-robotic-arm
					v-if="getActivePath[1]==7&&(getActiveMain[0]==4)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-axis-robotic-arm>

					<x-solution-multi-axis-motion-platform
					v-if="getActivePath[1]==7&&(getActiveMain[0]==5)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-multi-axis-motion-platform>

					<x-solution-servo-system
					v-if="getActivePath[1]==7&&(getActiveMain[0]==6)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-servo-system>
					<!------------------------------------------------------------------------------------------------->
					<!--<x-solution-servo-system
					v-if="getActivePath[1]==8&&(getActiveMain[0]==1||getActiveMain[0]==8)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-servo-system>-->
					<!------------------------------------------------------------------------------------------------->
					<x-solution3d-scanner
					v-if="getActivePath[1]==9&&(getActiveMain[0]==1)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution3d-scanner>

					<x-solution-plane-measuring-instrument-machine
					v-if="getActivePath[1]==9&&(getActiveMain[0]==2)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-plane-measuring-instrument-machine>

					<x-solution-tools-measuring-software
					v-if="getActivePath[1]==9&&(getActiveMain[0]==3)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-tools-measuring-software>

					<x-solution-optical-key-recognition-tool
					v-if="getActivePath[1]==9&&(getActiveMain[0]==4)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-optical-key-recognition-tool>

					<x-solution-three-dimensional-imaging
					v-if="getActivePath[1]==9&&(getActiveMain[0]==5)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-three-dimensional-imaging>

					<x-solution-binocular-vision
					v-if="getActivePath[1]==9&&(getActiveMain[0]==6)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-binocular-vision>

					<x-solution-intelligent-ci-assifiction
					v-if="getActivePath[1]==9&&(getActiveMain[0]==7)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-intelligent-ci-assifiction>
					<!------------------------------------------------------------------------------------------------->

					<x-solution-intelligent-cnc-workshop
					v-if="getActivePath[1]==10&&(getActiveMain[0]==1)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-intelligent-cnc-workshop>

					<x-solution-automatic-complete-production-line
					v-if="getActivePath[1]==10&&(getActiveMain[0]==2)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-automatic-complete-production-line>

					<x-solution-ultra-processing-equipment
					v-if="getActivePath[1]==10&&(getActiveMain[0]==3)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-ultra-processing-equipment>

					<x-solution-overall-for-autimatic-test-equipment
					v-if="getActivePath[1]==10&&(getActiveMain[0]==4)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-overall-for-autimatic-test-equipment>
					<!------------------------------------------------------------------------------------------------->

					<x-solution-developing-modules
					v-if="getActivePath[1]==13&&(getActiveMain[0]==1||getActiveMain[0]==13)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-developing-modules>

					<!------------------------------------------------------------------------------------------------->

					<x-solution-manufacturing-exection-system
					v-if="getActivePath[1]==12&&(getActiveMain[0]==1)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-manufacturing-exection-system>

					<x-solution-intelligent-equipment-management-system
					v-if="getActivePath[1]==12&&(getActiveMain[0]==2)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"
					></x-solution-intelligent-equipment-management-system>

					<x-solution-fast-dashboard-palyer
					v-if="getActivePath[1]==12&&(getActiveMain[0]==3)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-fast-dashboard-palyer>

					<!------------------------------------------------------------------------------------------------->

					<x-solution-services-indistrial-internet-things
					v-if="getActivePath[1]==11&&(getActiveMain[0]==1||getActiveMain[0]==11)"
					:activeSideIndex="activeSideIndex"
					@go="activeTo"></x-solution-services-indistrial-internet-things>

				</template>
				<template v-else>
				</template>
			</div>
			<!--加入我们-->
			<div class="main-con" v-if="$name=='join'">
				<template v-if="getActiveMain">
					<x-join-why v-if="getActiveMain[0]==1"></x-join-why>
					<x-join-social v-if="getActiveMain[0]==2"></x-join-social>
					<x-join-campus v-if="getActiveMain[0]==3"></x-join-campus>
				</template>
				<template v-else>
					<x-join-why></x-join-why>
				</template>
			</div>
			<!--新闻要点-->
			<div class="main-con" v-if="$name=='news'">
				<template v-if="getActiveMain">
					<x-news-global v-if="getActiveMain[0]==1" @go="activeTo"></x-news-global>
				</template>
				<template v-else>
					<x-news-global @go="activeTo"></x-news-global>
				</template>
			</div>
			<!--技术支持-->
			<div class="main-con" v-if="$name=='support'">
				<template v-if="getActivePath">
					<!--<template>{{ getActivePath}} : {{ getActiveMain }}</template>-->
					<!------------------------------------------------------------------------------------------------->
					<!--Key Cutting Machine Series-->
					<x-support-tech v-if="getActivePath[1]==1&&getActiveMain[0]==1"
									:activeSideIndex="activeSideIndex" @go="activeTo"></x-support-tech>
					<!--Remote and Transponder-->
					<x-support-tech-remote-transponder v-if="getActivePath[1]==1&&getActiveMain[0]==2"
													   :activeSideIndex="activeSideIndex"></x-support-tech-remote-transponder>
					<!--Remote and Transponder-->
					<x-support-detail v-if="getActivePath[1]==1&&getActiveMain[0]==3"
									  :activeSideIndex="activeSideIndex"></x-support-detail>
					<!------------------------------------------------------------------------------------------------->
					<!--Key Cutting Machine Series-->
					<x-support-videos v-if="getActivePath[1]==2&&getActiveMain[0]==1"
									  :activeSideIndex="activeSideIndex"></x-support-videos>
					<!--KEY TOOL&MINI KEY TOOl-->
					<x-support-mini-key-tool v-if="getActivePath[1]==2&&getActiveMain[0]==2"
											 :activeSideIndex="activeSideIndex"></x-support-mini-key-tool>
					<!--APP Functions-->
					<x-support-app-functions v-if="getActivePath[1]==2&&getActiveMain[0]==3"
											 :activeSideIndex="activeSideIndex"></x-support-app-functions>
					<!--Remote and Transponder-->
					<x-support-remote-sponder v-if="getActivePath[1]==2&&getActiveMain[0]==4"
											  :activeSideIndex="activeSideIndex"></x-support-remote-sponder>
					<!--KEY TOOL MAX-->
					<x-support-key-tool-max v-if="getActivePath[1]==2&&getActiveMain[0]==5"
											:activeSideIndex="activeSideIndex"></x-support-key-tool-max>
					<!--MINI OBD-->
					<x-support-mini-obd v-if="getActivePath[1]==2&&getActiveMain[0]==6"
										:activeSideIndex="activeSideIndex"></x-support-mini-obd>
				</template>
				<template v-else>
					<!--default-->
					<x-support-tech :activeSideIndex="activeSideIndex" @go="activeTo"></x-support-tech>
				</template>
			</div>
		</transition>
	</div>
</template>

<script>
	/*关于我们*/
    import xAboutXhorse from '@/components/zh-cn/about/about-xhorse.vue'
    import xAboutPatents from '@/components/zh-cn/about/about-patents.vue'
    import xAboutBusiness from '@/components/zh-cn/about/about-business.vue'
    import xAboutPower from '@/components/zh-cn/about/about-power.vue'
    import xAboutEmploye from '@/components/zh-cn/about/about-employe.vue'
    import xAboutRespons from '@/components/zh-cn/about/about-respons.vue'
    import xAboutWhere from '@/components/zh-cn/about/about-where.vue'
	/*加入我们*/
    import xJoinWhy from '@/components/zh-cn/join/join-why.vue'
    import xJoinSocial from '@/components/zh-cn/join/join-social.vue'
    import xJoinCampus from '@/components/zh-cn/join/join-campus.vue'
	/*新闻*/
    import xNewsGlobal from '@/components/zh-cn/news/news-global.vue'
	/*技术支持*/
    import xSupportTech from '@/components/zh-cn/support/support-tech.vue'
    import xSupportTechRemoteTransponder from '@/components/zh-cn/support/support-tech-remote-transponder.vue'
    import xSupportVideos from '@/components/zh-cn/support/support-videos.vue'
    import xSupportDetail from '@/components/zh-cn/support/support-detail.vue'
    import xSupportMiniKeyTool from '@/components/zh-cn/support/support-mini-key-tool.vue'
    import xSupportAppFunctions from '@/components/zh-cn/support/support-app-functions.vue'
    import xSupportRemoteSponder from '@/components/zh-cn/support/support-remote-transponder.vue'
    import xSupportKeyToolMax from '@/components/zh-cn/support/support-key-tool-max.vue'
    import xSupportMiniObd from '@/components/zh-cn/support/support-mini-obd.vue'
	/*解决方案*/
    import xSolutionKeyCuttingMachine from '@/components/zh-cn/solution/solution-key-cutting-machine.vue'
    import xSolutionVvdiSeries from '@/components/zh-cn/solution/solution-vvdi-series.vue'
    import xSolutionVvdiUniversalRemoteSeries from '@/components/zh-cn/solution/solution-vvdi-universal-remote-series.vue'
    import xSolutionIcProgrammers from '@/components/zh-cn/solution/solution-ic-programmers.vue'
    import xSolutionAccess from '@/components/zh-cn/solution/solution-access.vue'
    import xSolutionHpc from '@/components/zh-cn/solution/solution-hpc.vue'
    import xSolutionXhorseAsicTeam from '@/components/zh-cn/solution/solution-xhorse-asic-team.vue'
    import xSolutionDesktopAsixEngraving from '@/components/zh-cn/solution/solution-desktop-axis-engraving.vue'
    import xSolutionAxisToolSharpener from '@/components/zh-cn/solution/solution-axis-tool-sharpener.vue'
    import xSolutionDentalCarvingMachine from '@/components/zh-cn/solution/solution-dental-carving-machine.vue'
    import xSolutionAxisRoboticArm from '@/components/zh-cn/solution/solution-axis-robotic-arm.vue'
    import xSolutionMultiAxisMotionPlatform from '@/components/zh-cn/solution/solution-multi-axis-motion-platform.vue'
    import xSolutionServoSystem from '@/components/zh-cn/solution/solution-servo-system.vue'
    import xSolution3dScanner from '@/components/zh-cn/solution/solution-3d-scanner.vue'
    import xSolutionPlaneMeasuringInstrumentMachine from '@/components/zh-cn/solution/solution-plane-measuring-instrument-machine.vue'
    import xSolutionToolsMeasuringSoftware from '@/components/zh-cn/solution/solution-tools-measuring-software.vue'
    import xSolutionOpticalKeyRecognitionTool from '@/components/zh-cn/solution/solution-optical-key-recognition-tool.vue'
    import xSolutionThreeDimensionalImaging from '@/components/zh-cn/solution/solution-three-dimensional-imaging.vue'
    import xSolutionBinocularVision from '@/components/zh-cn/solution/solution-binocular-vision.vue'
    import xSolutionIntelligentCiAssifiction from '@/components/zh-cn/solution/solution-intelligent-object-ci-assification.vue'
    import xSolutionIntelligentCncWorkshop from '@/components/zh-cn/solution/solution-intelligent-cnc-workshop.vue'
    import xSolutionUltraProcessingEquipment from '@/components/zh-cn/solution/solution-ultra-processing-equipment.vue'
    import xSolutionAutomaticCompleteProductionLine from '@/components/zh-cn/solution/solution-automatic-complete-production-line.vue'
    import xSolutionOverallForAutimaticTestEquipment from '@/components/zh-cn/solution/solution-overall-for-automatic-test-equipment.vue'
    import xSolutionManufacturingExectionSystem from '@/components/zh-cn/solution/solution-manufacturing-execution-system.vue'
    import xSolutionIntelligentEquipmentManagementSystem from '@/components/zh-cn/solution/solution-intelligent-equipment-management-system.vue'
    import xSolutionFastDashboardPalyer from '@/components/zh-cn/solution/solution-fast-dashboard-palyer.vue'
    import xSolutionServicesIndistrialInternetThings from '@/components/zh-cn/solution/solution-system-level-machining-accuracy-assurance.vue'
    import xSolutionDevelopingModules from '@/components/zh-cn/solution/solution-developing-modules.vue'
    export default {
        components: {
			/*关于我们*/
            xAboutXhorse: xAboutXhorse,
            xAboutPatents: xAboutPatents,
            xAboutBusiness: xAboutBusiness,
            xAboutPower: xAboutPower,
            xAboutEmploye: xAboutEmploye,
            xAboutRespons: xAboutRespons,
            xAboutWhere: xAboutWhere,
			/*加入我们*/
            xJoinWhy: xJoinWhy,
            xJoinSocial: xJoinSocial,
            xJoinCampus: xJoinCampus,
			/*新闻*/
            xNewsGlobal: xNewsGlobal,
			/*技术支持*/
            xSupportTech: xSupportTech,
            xSupportVideos: xSupportVideos,
            xSupportDetail: xSupportDetail,
            xSupportMiniKeyTool: xSupportMiniKeyTool,
            xSupportAppFunctions: xSupportAppFunctions,
            xSupportRemoteSponder: xSupportRemoteSponder,
            xSupportKeyToolMax: xSupportKeyToolMax,
            xSupportMiniObd: xSupportMiniObd,
            xSupportTechRemoteTransponder: xSupportTechRemoteTransponder,
			/*解决方案*/
            xSolutionKeyCuttingMachine: xSolutionKeyCuttingMachine,
            xSolutionVvdiSeries: xSolutionVvdiSeries,
            xSolutionVvdiUniversalRemoteSeries: xSolutionVvdiUniversalRemoteSeries,
            xSolutionIcProgrammers: xSolutionIcProgrammers,
            xSolutionAccess: xSolutionAccess,
            xSolutionHpc: xSolutionHpc,
            xSolutionXhorseAsicTeam: xSolutionXhorseAsicTeam,
            xSolutionDesktopAsixEngraving: xSolutionDesktopAsixEngraving,
            xSolutionAxisToolSharpener: xSolutionAxisToolSharpener,
            xSolutionDentalCarvingMachine: xSolutionDentalCarvingMachine,
            xSolutionAxisRoboticArm: xSolutionAxisRoboticArm,
            xSolutionMultiAxisMotionPlatform: xSolutionMultiAxisMotionPlatform,
            xSolutionServoSystem: xSolutionServoSystem,
            xSolution3dScanner: xSolution3dScanner,
            xSolutionPlaneMeasuringInstrumentMachine: xSolutionPlaneMeasuringInstrumentMachine,
            xSolutionToolsMeasuringSoftware: xSolutionToolsMeasuringSoftware,
            xSolutionOpticalKeyRecognitionTool: xSolutionOpticalKeyRecognitionTool,
            xSolutionThreeDimensionalImaging: xSolutionThreeDimensionalImaging,
            xSolutionBinocularVision: xSolutionBinocularVision,
            xSolutionIntelligentCiAssifiction: xSolutionIntelligentCiAssifiction,
            xSolutionIntelligentCncWorkshop: xSolutionIntelligentCncWorkshop,
            xSolutionUltraProcessingEquipment: xSolutionUltraProcessingEquipment,
            xSolutionAutomaticCompleteProductionLine: xSolutionAutomaticCompleteProductionLine,
            xSolutionOverallForAutimaticTestEquipment: xSolutionOverallForAutimaticTestEquipment,
            xSolutionManufacturingExectionSystem: xSolutionManufacturingExectionSystem,
            xSolutionIntelligentEquipmentManagementSystem: xSolutionIntelligentEquipmentManagementSystem,
            xSolutionFastDashboardPalyer: xSolutionFastDashboardPalyer,
            xSolutionServicesIndistrialInternetThings: xSolutionServicesIndistrialInternetThings,
            xSolutionDevelopingModules: xSolutionDevelopingModules
        },
        props: {
            activeSideIndex: {
                type: Array,
            },
            activeTopIndex: {
                type: Array,
            },
            aboutMainStyle: null
        },
        data: function () {
            return {
                activeClass: ''
            };
        },
        methods: {
            activeTo(params){
				/*console.log("Template[main]: ", params)*/
                const _this = this;
                const componentInfo = _this.$RegistedName;
                const dateTime = (new Date()).getTime()
                if (params.type == 'top') {
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeTopIndex = fullPath;
                    _this.activeSideIndex = fullPath.slice(-1);
                    _this.$router.push({name: componentInfo[fullPath[0]].componentName, params: {date: dateTime}})
                } else {
                    _this.activeSideIndex = params.val
                }
            }
        },
        computed: {
            getActivePath: function () {
                const _this = this;
                var fullPath = _this.activeTopIndex.map((item) => {
                    return parseInt(item)
                });
                return fullPath.length > 0 ? fullPath : false;
            },
            getActiveMain: function () {
                const _this = this;
                var activeMain = _this.activeSideIndex.map((item) => {
                    return parseInt(item);
                });
                return activeMain.length > 0 ? activeMain : false;
            }
        },
        watch: {
            activeSideIndex: function (latest) {
                const _this = this;
				/*console.log("[activeTopIndex]:[ActiveSIdeIndex]", [_this.activeTopIndex, latest])*/
                _this.activeSideIndex = latest;
            },
            activeTopIndex: function (latest) {

            },
        },
    }

</script>

<style scoped>

	@import "../../assets/css/main.css";

</style>



// WEBPACK FOOTER //
// src/components/zh-cn/main.vue